import { NgModule } from '@angular/core';

import { AnalyticsService, ModalSpinnerService } from '@reef/core';
import { CoreService } from './store/core.service';
import { DummyAnalyticsService } from './services/dummy-analytics.service';

@NgModule({
  providers: [
    {provide: AnalyticsService, useClass: DummyAnalyticsService},
    CoreService,
    ModalSpinnerService,
  ],
})
export class CoreModule {
}
